import {
  ConfigService
} from '@/services/api'
import appConfig from '@/config'

import ItemTemplate from '@/components/Maps/InfoTextTemplates/Item'

function flattenObject(obj) {
  const toReturn = {}

  for (const i in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue

    if ((typeof obj[i]) === 'object' && obj[i] !== null) {
      const flatObject = flattenObject(obj[i])
      for (const x in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = obj[i]
    }
  }
  return toReturn
}

function unflattenObject(obj) {
  const result = {}
  for (const i in obj) {
    const keys = i.split('.')
    keys.reduce(function (r, e, j) {
      return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? obj[i] : {}) : [])
    }, result)
  }
  return result
}

function renameKeys(obj, fn) {
  if (typeof fn !== 'function') {
    return obj
  }

  const keys = Object.keys(obj)
  const result = {}

  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    const val = obj[key]
    const str = fn(key, val)
    if (typeof str === 'string' && str !== '') {
      key = str
    }
    result[key] = val
  }
  return result
}

function setFilters(filters, currentFilters = {}) {
  filters.columns.forEach(column => {
    column.filters.forEach(filter => {
      if (filter.name) {
        currentFilters = { ...currentFilters, [filter.name]: filter.value }
      } else {
        return setFilters(filter, currentFilters)
      }
    })
  })
  return currentFilters
}

export default {
  state: {
    ecosystem: {
      product: 'gcm2',
      siteName: 'Moova',
      logo: '/static/img/moova.svg',
      logoLogin: '/static/img/moova-blue.svg',
      theme: 'moova',
      helpUrl: 'http://ayuda.moova.io/',
      googleRegister: true,
      terms: 'https://moova.io/terminos-y-condiciones/',
      privacy: 'https://moova.io/politica-de-privacidad/'
    },
    ecosystemCountries: [],
    frontConfig: {},
    ecosystemConfig: {
      links: {
        help: '',
        terms: '',
        privacy: ''
      },
      googleRegister: false,
      extraCheckpoints: {
        beforePickup: false,
        beforeDelivery: false
      }
    },
    ecosystemModules: {
      couriers: {
        self: true
      },
      shippings: {
        self: true,
        shared: true
      },
      tours: {
        self: true,
        shared: true
      },
      items: {
        self: false,
        label: null,
        geolocalizableBy: null,
        templateInfoText: ItemTemplate.templateInfoText,
        icon: ItemTemplate.icon
      },
      geofences: false,
      companies: true,
      transactions: true,
      stores: {
        self: false,
        label: null
      }
    },
    ecosystemPlugins: null,
    ecosystemMaps: null,
    ecosystemBranding: {},
    models: {},
    dataTransformers: {},
    quickFiltersSetup: {},
    plainQuickFiltersSetup: {},
    appRoles: [],
    vehicleTypes: [],
    shippingSizes: [],
    shippingTypes: [],
    shippingTypesShared: [],
    shippingSettings: [],
    platforms: [],
    receiverTypes: [],
    shippingStatusReasons: {},
    tobereturnedStatusReasons: [],
    geoTypes: [],
    spinner: false,
    vehicleTypeGroupVehicleTypes: [],
    commodityVarieties: []
  },
  getters: {
    ecosystem: state => {
      return state.ecosystem
    },
    // Brand shown in user-facing copy: the ecosystem branding name (with the product override, as the backend does)
    brandName: state => {
      return state.ecosystemBranding.name || state.ecosystem.siteName
    },
    ecosystemCountries: state => {
      return state.ecosystemCountries
    },
    frontConfig: state => {
      return state.frontConfig
    },
    ecosystemConfig: state => {
      return state.ecosystemConfig
    },
    ecosystemModules: state => {
      return state.ecosystemModules
    },
    ecosystemPlugins: state => {
      return state.ecosystemPlugins
    },
    ecosystemMaps: state => {
      return state.ecosystemMaps
    },
    models: state => {
      return state.models
    },
    dataTransformers: state => {
      return state.dataTransformers
    },
    quickFiltersSetup: state => {
      return state.quickFiltersSetup
    },
    plainQuickFiltersSetup: state => {
      return state.plainQuickFiltersSetup
    },
    appRoles: state => {
      return state.appRoles
    },
    vehicleTypes: state => {
      return state.vehicleTypes
    },
    vehicleTypesSelect: state => {
      return state.vehicleTypes.map((item) => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
    shippingSizes: state => {
      return state.shippingSizes
    },
    shippingTypes: state => {
      return state.shippingTypes
    },
    shippingTypesShared: state => {
      return state.shippingTypesShared
    },
    flexShippingTypeId: state => {
      return (state.shippingTypesShared.find(x => x.text === 'mercado_flex') || {}).value || null
    },
    shippingSettings: state => {
      return state.shippingSettings
    },
    platforms: state => {
      return state.platforms
    },
    receiverTypes: state => {
      return state.receiverTypes
    },
    shippingStatusReasons: state => {
      return state.shippingStatusReasons
    },
    tobereturnedStatusReasons: state => {
      return state.tobereturnedStatusReasons
    },
    geoTypes: state => {
      return state.geoTypes
    },
    spinner: state => {
      return state.spinner
    },
    vehicleTypeGroupVehicleTypes: state => {
      return state.vehicleTypeGroupVehicleTypes
    },
    commodityVarieties: state => {
      return state.commodityVarieties
    }
  },
  mutations: {
    checkEcosystem: (state, payload) => {
      console.log(ConfigService.getEcosystems())
    },
    setEcosystem: (state, payload) => {
      console.log(payload)
      if (payload) {
        document.documentElement.className = payload.theme
        state.ecosystem = payload
      }
    },
    setEcosystemCountries: (state, payload) => {
      console.log(state.eid)
      console.log(payload)
      return ConfigService.getCountries(payload)
        .then(response => {
          state.ecosystemCountries = response.body.data
          window.countries = response.body.data
        })
    },
    setFrontConfig: (state, payload) => {
      if (payload) {
        state.frontConfig = payload
      }
    },
    setEcosystemModules: (state, payload) => {
      console.log(state.eid)
      console.log(payload)
      return ConfigService.getEcosystem(payload)
        .then(response => {
          const branding = response.body.branding || {}
          state.ecosystemBranding = { ...branding, ...branding[appConfig.product] }
          console.log(response.body.front_config)
          if (response.body.front_config?.modules) {
            state.ecosystemModules = { ...state.ecosystemModules, ...response.body.front_config.modules, remote: true }
            // Any modules override for current product?
            if (response.body.front_config[appConfig.product]?.modules) {
              state.ecosystemModules = { ...state.ecosystemModules, ...response.body.front_config[appConfig.product].modules }
            }
          } else {
            state.ecosystemModules = { ...state.ecosystemModules, remote: true }
          }
          if (response.body.front_config?.general) {
            state.ecosystemConfig = { ...response.body.front_config.general, ...{ remote: true } }
            // Any config override for current product?
            if (response.body.front_config[appConfig.product]?.general) {
              state.ecosystemConfig = { ...state.ecosystemConfig, ...response.body.front_config[appConfig.product].general }
            }
          }
          if (response.body.front_config?.plugins) {
            state.ecosystemPlugins = { ...response.body.front_config.plugins, ...{ remote: true } }
            // Any plugins override for current product?
            if (response.body.front_config[appConfig.product]?.plugins) {
              state.ecosystemPlugins = { ...state.ecosystemPlugins, ...response.body.front_config[appConfig.product].plugins }
            }
          }
          if (response.body.front_config?.maps) {
            // TODO: refactor this :/
            response.body.front_config.maps.providers = response.body.front_config.maps.providers.map(x => {
              const provider = flattenObject(x)
              for (const key in provider) {
                if (Object.prototype.hasOwnProperty.call(provider, key)) {
                  if (typeof provider[key] === 'string') {
                    const matches = provider[key].match(/{{([^}]+)}}/g)
                    if (Array.isArray(matches) && matches.length > 0) {
                      for (const keyToReplace of matches) {
                        provider[key] = provider[key].replace(/{{([^}]+)}}/g, provider[keyToReplace.replace('{{', '').replace('}}', '')])
                      }
                    }
                  }
                }
              }
              return unflattenObject(provider)
            })
            state.ecosystemMaps = { ...response.body.front_config.maps, ...{ remote: true } }
          }
          if (response.body.front_config?.ecosystem) {
            state.ecosystem = { ...state.ecosystem, ...response.body.front_config.ecosystem }
            if (response.body.front_config[appConfig.product]?.ecosystem) {
              state.ecosystem = { ...state.ecosystem, ...response.body.front_config[appConfig.product].ecosystem }
            }
          }
        })
    },
    setModels: (state, payload) => {
      console.log('models', JSON.parse(JSON.stringify(payload)))
      if (payload) {
        state.models = renameKeys(payload, function (key, val) {
          return key.replace('Model', '')
        })
      }
    },
    setDataTransformers: (state, payload) => {
      if (payload) {
        state.dataTransformers = payload
      }
    },
    setQuickFilters: (state, payload) => {
      console.log('quickFiltersSetup', JSON.parse(JSON.stringify(payload)))
      if (payload) {
        // state.quickFiltersSetup = payload
        state.quickFiltersSetup = renameKeys(payload, function (key, val) {
          return key.replace('QuickFilters', '')
        })
        for (const key in state.quickFiltersSetup) {
          if (Object.prototype.hasOwnProperty.call(state.quickFiltersSetup, key)) {
            const element = state.quickFiltersSetup[key]
            state.plainQuickFiltersSetup[key] = setFilters(element.filters)
          }
        }
        console.log(state.plainQuickFiltersSetup)
      }
    },
    setAppRoles: (state, payload) => {
      return ConfigService.getRoles(payload)
        .then(response => {
          const appRoles = response.body.data
            .filter(item => window.allowedRoles.map(x => x.role).indexOf(item.name) !== -1)
            .map(item => ({ value: item.id, text: item.name }))
          setTimeout(() => {
            state.appRoles = appRoles
            window.allowedRoles = window.allowedRoles.filter(x => state.appRoles.map(y => y.text).indexOf(x.role) !== -1)
          }, 1000)
        })
    },
    setVehicleTypes: (state, payload) => {
      return ConfigService.getVehicleTypes(payload)
        .then(response => {
          state.vehicleTypes = response.body.data
        })
    },
    setShippingSizes: (state, payload) => {
      return ConfigService.getShippingSizes(payload)
        .then(response => {
          state.shippingSizes = response.body.data
        })
    },
    setShippingTypes: (state, payload) => {
      return ConfigService.getShippingTypes(payload)
        .then(response => {
          state.shippingTypesShared = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          state.shippingTypes = response.body.data
            .filter(item => window.allowedShippingTypes.indexOf(item.name) !== -1)
            .map(item => ({ value: item.id, text: item.name }))
        })
    },
    setShippingSettings: (state, payload) => {
      return ConfigService.getShippingSettings(payload)
        .then(response => {
          state.shippingSettings = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          }).filter(Boolean)
        })
    },
    setPlatforms: (state, payload) => {
      return ConfigService.getPlatforms(payload)
        .then(response => {
          state.platforms = response.body.data
        })
    },
    setReceiverTypes: (state, payload) => {
      return ConfigService.getReceiverTypes(payload)
        .then(response => {
          state.receiverTypes = response.body.data
        })
    },
    setShippingStatusReasons: (state, payload) => {
      return ConfigService.getShippingStatusReasons(payload)
        .then(response => {
          state.shippingStatusReasons = response.body.data
          for (let i = 0; i < response.body.data.length; i++) {
            if (!state.shippingStatusReasons[response.body.data[i].event]) {
              state.shippingStatusReasons[response.body.data[i].event] = []
            }
            // reset the shipping_status_reasons events to match shipping statuses
            if (response.body.data[i].event === 'PICKEDUP') {
              response.body.data[i].event = 'CONFIRMED'
            } else if (response.body.data[i].event === 'DELIVERED') {
              state.tobereturnedStatusReasons.push({ name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id })
              response.body.data[i].event = 'INTRANSIT'
            }
            state.shippingStatusReasons[response.body.data[i].event].push({ name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id })
          }
        })
    },
    setGeoTypes: (state, payload) => {
      return ConfigService.getGeoTypes(payload)
        .then(response => {
          state.geoTypes = response.body.data
        })
    },
    showSpinner: (state) => {
      state.spinner = true
    },
    hideSpinner: (state) => {
      state.spinner = false
    },
    setVehicleTypeGroupVehicleTypes: (state, payload) => {
      state.vehicleTypeGroupVehicleTypes = payload
    },
    setCommodityVarieties: (state, payload) => {
      state.commodityVarieties = payload
    }
  },
  actions: {
    checkEcosystem: ({ commit }, payload) => {
      commit('checkEcosystem', payload)
    },
    setEcosystem: ({ commit }, payload) => {
      commit('setEcosystem', payload)
    },
    setEcosystemCountries: ({ commit }, payload) => {
      commit('setEcosystemCountries', payload)
    },
    setFrontConfig: ({ commit }, payload) => {
      commit('setFrontConfig', payload)
    },
    setEcosystemModules: ({ commit }, payload) => {
      commit('setEcosystemModules', payload)
    },
    setModels: ({ commit }, payload) => {
      commit('setModels', payload)
    },
    setDataTransformers: ({ commit }, payload) => {
      commit('setDataTransformers', payload)
    },
    setQuickFilters: ({ commit }, payload) => {
      commit('setQuickFilters', payload)
    },
    setAppRoles: ({ commit }, payload) => {
      commit('setAppRoles', payload)
    },
    setVehicleTypes: ({ commit }, payload) => {
      commit('setVehicleTypes', payload)
    },
    setShippingSizes: ({ commit }, payload) => {
      commit('setShippingSizes', payload)
    },
    setShippingTypes: ({ commit }, payload) => {
      commit('setShippingTypes', payload)
    },
    setShippingSettings: ({ commit }, payload) => {
      commit('setShippingSettings', payload)
    },
    setPlatforms: ({ commit }, payload) => {
      commit('setPlatforms', payload)
    },
    setReceiverTypes: ({ commit }, payload) => {
      commit('setReceiverTypes', payload)
    },
    setShippingStatusReasons: ({ commit }, payload) => {
      commit('setShippingStatusReasons', payload)
    },
    setGeoTypes: ({ commit }, payload) => {
      commit('setGeoTypes', payload)
    },
    showSpinner: ({ commit }) => {
      commit('showSpinner')
    },
    hideSpinner: ({ commit }) => {
      commit('hideSpinner')
    },
    setVehicleTypeGroupVehicleTypes: ({ commit }, payload) => {
      commit('setVehicleTypeGroupVehicleTypes', payload)
    },
    setCommodityVarieties: ({ commit }, payload) => {
      commit('setCommodityVarieties', payload)
    }
  }
}
